import { images } from "../source";

export const interviewsData = [
  // Addiction category
  {
    id: 21,
    type: "video",
    // subType: "audio",
    img: images.interview21.image,
    mbImg: images.interviewMB21.image,
    alt: images.interview21.alt,
    title: "I Changed My Perspective On Life - Nothing Has Been The Same Since With Marouf Tirad",
    desc: `
    In this special season two episode, guest host Tara Hoyes-Martinez turns the lens on Marouf himself. He opens up about the highs and losses that shaped him, building a school in Gaza, racing bikes across Europe, losing his father, and a single meditation session that changed everything, tracing the path all the way to India and the birth of Pathways and Perspectives.
    `,
    video: "https://youtu.be/Yhw3eGqetgA",
    category: ["Transformation", "Spirituality & Religion", "Yoga", "Meditation", "Perspective Shift"],
    interviewDate: "2026-09-21",
  },
  {
    id: 20,
    type: "video",
    // subType: "audio",
    img: images.interview20.image,
    mbImg: images.interviewMB20.image,
    alt: images.interview20.alt,
    title: "He Simulated Death for 7 Days in Total Darkness | Tantra & Soma Breath",
    desc: `
    Former pharmacist and Soma Breath founder Niraj Naik sits down to talk Tantra, breathwork, and the fear of death. He shares what Tantra really means beyond sex, his experience surviving a seven-day darkness retreat in India, and how breathwork can be used to access altered states and inner wellbeing without substances. The conversation closes on mortality, daily practice, and living with more consciousness.
    `,
    video: "https://youtu.be/gf9Kwe6jmJs",
    category: ["Ayurveda", "Breathwork", "Meditation", "Tantra"],
    interviewDate: "2026-09-07",
  },
  {
    id: 19,
    type: "video",
    // subType: "audio",
    img: images.interview19.image,
    mbImg: images.interviewMB19.image,
    alt: images.interview19.alt,
    title: "Placenta Isn't Medical Waste: What Parents Should Know Before Giving Birth",
    desc: `
    In this episode of Pathways & Perspectives, Marouf sits down with Robin Lim, internationally recognized midwife, author, and founder of the Bumi Sehat Foundation in Bali. Robin shares how becoming a teenage mother, growing up in a family of traditional midwives, and losing her sister to pregnancy complications shaped her life's work. The conversation moves through gentle birth, breastfeeding, cesarean birth, and the role of fathers, before landing on its central theme: why Robin believes the placenta deserves far more respect than being treated as medical waste, and what lotus birth actually involves. Along the way, she recounts one of the most extraordinary moments of her career, delivering a baby and managing a postpartum hemorrhage mid-flight over the Pacific.
    `,
    video: "https://youtu.be/52MzSwB9aQA",
    category: ["Holistic Health", "Spirituality & Religion", "Motherhood"],
    interviewDate: "2026-08-20",
  },
  {
    id: 18,
    type: "video",
    // subType: "audio",
    img: images.interview18.image,
    mbImg: images.interviewMB18.image,
    alt: images.interview18.alt,
    title: "Everything You Know About Men is Wrong With Aaron Kleinerman",
    desc: `
    In this episode, Marouf sits down with transformational coach and author Aaron Kleinerman to explore masculinity, emotional expression, relationships, and the meaning of strength. Aaron reflects on growing up in a chaotic family environment outside Boston, and how a direct conversation with his father at fourteen changed the course of their relationship. Together they examine why many men struggle to ask for support, the difference between power and vulnerability, and what it means to live as an integrated man today.
    `,
    video: "https://youtu.be/v8FMqpYbGAs",
    category: ["Family"],
    interviewDate: "2026-07-10",
  },
  {
    id: 17,
    type: "video",
    // subType: "audio",
    img: images.interview17.image,
    mbImg: images.interviewMB17.image,
    alt: images.interview17.alt,
    title: "Mike Chang – From Six Pack Shortcuts to Nervous System Mastery",
    desc: `
    Join Mike Chang as he unpacks the unexpected pivot behind one of the biggest names in online fitness. After building Six Pack Shortcuts into a multimillion-dollar YouTube empire, Mike walked away at the height of its success, questioning the identity that had driven him there. This conversation traces his journey from a childhood shaped by hardship in Houston to the moment he confronted the stories fuelling his relentless pursuit of achievement. Mike shares his philosophy on nervous system regulation, movement, and breathwork through Flow60, revealing how physical practice can reshape mindset and emotional wellbeing. Learn how becoming aware of the stories we tell ourselves can be the first step toward lasting transformation.
    `,
    video: "https://youtu.be/VHLMUItAFaY",
    category: ["Transformation"],
    interviewDate: "2026-07-10",
  },
  {
    id: 16,
    type: "video",
    // subType: "audio",
    img: images.interview16.image,
    mbImg: images.interviewMB16.image,
    alt: images.interview16.alt,
    title: "Annemarie Brown - Vedic Astrology Explained = Discover Your Cosmic Blueprint & Life Purpose",
    desc: `
    Unlock the mysteries of the cosmos with Annemarie Brown, the insightful founder of Sattva Gems, an online business specializing in astrological gems. Annemarie demystifies Vedic astrology, explaining what it truly is beyond simple horoscopes. More importantly, she shares practical, actionable applications for this ancient science, demonstrating how understanding your unique cosmic blueprint can guide you in everyday decisions, from career choices to personal well-being. Discover how to harness the subtle energies of the universe for a more aligned and fulfilling life.
    `,
    video: "https://youtu.be/IkcX7FK7GHg",
    category: ["Astrology", "India", "Meditation", "Yoga"],
    interviewDate: "2026-04-06",
  },
  {
    id: 15,
    type: "video",
    // subType: "audio",
    img: images.interview15.image,
    mbImg: images.interviewMB15.image,
    alt: images.interview15.alt,
    title: "Talks With Joelle Lahlouh - What you’re chosen for as a mother",
    desc: `
    In this moving and deeply human conversation, we sit down with Joelle to explore motherhood in all its beauty, weight, and transformation.
    <br><br>
    Joelle opens her heart about what it means to be chosen as the guide and guardian of a soul with different needs,  and how that calling reshaped her understanding of love, strength, and purpose. We speak about the quiet grief that can live alongside gratitude, and the inner worlds mothers often carry without words.
    <br><br>
    She shares how movement became a lifeline - A way back to herself during moments of heaviness, exhaustion, and emotional overwhelm. Through the body, she found release, resilience, and a reminder that healing is not linear, but lived.
    <br><br>
    At the core of her story is faith. A grounded, intimate trust in God that carries her through uncertainty and surrender. Together, we explore devotion, acceptance, and the sacred role of motherhood as a spiritual path -  One that teaches presence, patience, and profound love.
    `,
    video: "https://youtu.be/VTAnjE6Irys",
    category: ["Spirituality & Religion", "Wellness", "Family"],
    interviewDate: "2026-01-23",
  },
  {
    id: 14,
    type: "video",
    // subType: "audio",
    img: images.interview14.image,
    mbImg: images.interviewMB14.image,
    alt: images.interview14.alt,
    title: "Charlotte Holmes – Redefining Beauty, Strength, and Self",
    desc: `In this powerful conversation, we sit down with Charlotte Holmes;  yogi, teacher, and former Miss England — to explore what it truly means to rebuild a life from the inside out.
    <br><br>
    Charlotte opens up about the moments that challenged her identity, the expectations placed on women, and the courage it takes to walk away from what no longer feels true. We talk about resilience, self-worth, and the process of finding meaning beyond titles, roles, and appearances.
    <br><br>
    She shares how yoga became a practice of healing, grounding, and honest self-reflection — and how it helped her create a life rooted in purpose rather than perfection. Together, we explore themes of letting go, rebuilding trust with oneself, and discovering beauty as something lived, not just seen.
    `,
    video: "https://youtu.be/rW_4M2leIwE",
    category: [
      "Art & Fashion",
      "Health & Longevity",
      "India",
      "Meditation",
      "Sacred Feminine",
      "Sports",
      "Yoga",
    ],
    interviewDate: "2025-11-29",
  },
  {
    id: 13,
    type: "video",
    // subType: "audio",
    img: images.interview13.image,
    mbImg: images.interviewMB13.image,
    alt: images.interview13.alt,
    title:
      "Geshe Lama Ahbay Tulku Rinpoche - Buddhist Wisdom for a Peaceful Life",
    desc: `Step into the quiet wisdom of Tibetan Buddhism with Geshe Lama Ahbay Tulku Rinpoche, a devoted monk whose life is rooted in compassion and conscious presence. This conversation unpacks the path that led him to monkhood, offering gentle insight into the philosophy and daily practice behind this ancient tradition. Geshe Lama Ahbay Tulku Rinpoche brings clarity to what it means to love with and without attachment, revealing how true compassion arises when we allow others to be free.
    <br><br>
    He also shares simple, powerful ways to cultivate positive intention and send healing energy into the world — practices that remind us of our interconnectedness and our capacity to uplift one another.
    <br><br>
    Discover how these timeless teachings can bring more peace, balance, and awareness into your everyday life.
    `,
    video: "https://youtu.be/VvYovnEqmJo",
    category: ["History", "Meditation", "Spirituality & Religion"],
    interviewDate: "2025-11-19",
  },
  {
    id: 12,
    type: "video",
    // subType: "audio",
    img: images.interview12.image,
    mbImg: images.interviewMB12.image,
    alt: images.interview12.alt,
    title:
      "Marianna Harpreet - Conscious Business, Breaking Family Cycles & Building a Life of Purpose",
    desc: `Join us for a candid conversation with Marianna Harpreet, the visionary founder of the Deepak Foundation in Mallorca and organizer of the annual Sages & Scientists conference. Marianna shares her unique insights on the intersection of business and purpose, her deep connection to the island of Mallorca, and the underestimated role our family backgrounds play in shaping who we become. She also opens up about her journey as a woman in business, breaking generational patterns, and becoming the first in her family to own a company. </br>  </br> This interview offers a compelling look at building a meaningful life and career rooted in personal history, resilience, and a passion for giving back.
`,
    video: "https://youtu.be/a9WZINWe5G8",
    category: [
      "Philanthropy",
      "Politics",
      "Science",
      "Yoga",
      "Money",
      "Sacred Feminine",
      "Business",
      "Entrepreneurship",
      "Health & Longevity",
      "History",
      "Meditation",
    ],
    interviewDate: "2025-10-18",
  },
  {
    id: 11,
    type: "video",
    // subType: "audio",
    img: images.interview11.image,
    mbImg: images.interviewMB11.image,
    alt: images.interview11.alt,
    title:
      "Monika Vijh – Breaking Free from the Golden Cage: A Journey Beyond Life and Limit",
    desc: `Prepare for a truly profound experience with <strong>Monika Vijh</strong>, author of "Devotee of the Void." In this deeply personal interview, Monika shares the transformative account of her experience of dying and returning to life, offering unparalleled insights into existence beyond the veil. We also delve into her powerful reflections on breaking free from what she calls the "golden cage" – the unseen limitations and expectations that often bind us. The conversation is beautifully punctuated as Monika reads excerpts from her evocative poetry, adding another layer of depth to her unique wisdom.`,
    video: "https://youtu.be/_FVvKaehwdI",
    category: ["Yoga", "Spirituality & Religion", "Meditation"],
    interviewDate: "2025-09-19",
  },
  {
    id: 10,
    type: "video",
    // subType: "audio",
    img: images.interview10.image,
    mbImg: images.interviewMB10.image,
    alt: images.interview10.alt,
    title: "Gurmukh Khalsa – Kundalini, Madonna, and a Youthful Spirit",
    desc: "Prepare to be uplifted by the sheer presence and wisdom of Gurmukh Khalsa, the legendary Kundalini Yoga teacher. At 82, her power and clarity are undeniable as she shares her unique perspective on Kundalini, navigating the challenge of describing its essence when language falls short. Gurmukh offers insights from her life, including her experiences raising kids, and reveals how she cultivates her own child-like attitude and young spirit, which she helps others cultivate too. This is an interview brimming with potent lessons for all ages.",
    video: "https://youtu.be/wnD1XOT6pJ4",
    category: [
      "Meditation",
      "Yoga",
      "Spirituality & Religion",
      "Sacred Feminine",
    ],
    interviewDate: "2025-08-25",
  },
  {
    id: 5,
    type: "video",
    // subType: "audio",
    img: images.interview04.image,
    mbImg: images.interviewMB04.image,
    alt: images.interview04.alt,
    title: "Prabha Dawba – From Hollywood to the Heart of Service",
    desc: "Discover the extraordinary journey of Prabha Dawba, who, in her 20s, left the allure of Hollywood behind to sit at the feet of Osho. This inspiring interview chronicles her path to founding the Ramana Schools in North India, a remarkable non-profit organization that has provided free education to thousands of children. Prabha shares the profound lessons learned from her unique spiritual immersion and how it shaped her dedication to selfless service and creating lasting impact.",
    video: "https://youtu.be/NzOqfObTffk",
    category: ["Philanthropy", "Yoga", "Meditation", "India"],
    interviewDate: "2025-08-19",
  },
  {
    id: 3,
    type: "video",
    // subType: "audio",
    img: images.interview03.image,
    mbImg: images.interviewMB03.image,
    alt: images.interview03.alt,
    title: "Dr. Ramkumar – The Simple Wisdom of Ayurveda for Living Well",
    desc: "Step into the timeless wisdom of Ayurveda with Dr. Ramkumar, a revered expert from India. This conversation demystifies the ancient science of living well, breaking down practical advice on what to eat and the profound role of intention in our food choices. Dr. Ramkumar illuminates just how simple and intuitive Ayurveda truly is, revealing its deep connection to nature, cyclical living, and our inherent well-being. Learn how to integrate these powerful, natural principles into your daily life for enhanced health and harmony.",
    video: "https://www.youtube.com/watch?v=-QpE-Sr_NFs",
    category: ["Ayurveda", "Health & Longevity", "India"],
    interviewDate: "2025-08-01",
  },
  {
    id: 1,
    type: "video",
    // subType: "video",
    img: images.interview01.image,
    mbImg: images.interviewMB01.image,
    alt: images.interview01.alt,
    title: "Tommy Rosen – The Path to a Life of Freedom",
    desc: "Join us for a profound conversation with Tommy Rosen, a true pioneer in the world of recovery and conscious living. In this inspiring interview, we explore what a life of true freedom entails, touching on the transformative power of yoga and meditation. Tommy shares his unique insights on figures like Ram Dass, and offers a grounded perspective on psychedelics, emphasizing their role as tools when approached with deep respect and intention. Discover how yoga serves as a universal pathway to a full life, accessible and beneficial to individuals from any spiritual or religious background.",
    video: "https://www.youtube.com/watch?v=cz3FWtb_BOE&feature=youtu.be",
    category: ["Addiction", "Meditation", "Spirituality & Religion", "Yoga"],
    interviewDate: "2025-08-01",
  },


  // {
  //   id: 2,
  //   type: "audio",
  //   img: images.interview02.image,
  //   mbImg: images.interviewMB02.image,
  //   alt: images.interview02.alt,
  //   title: "Addiction and Mental Health: A Personal Journey",
  //   desc: "An inspiring audio interview with a recovering addict on their battle with addiction and mental health.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Addiction",
  //   interviewDate: "2024-12-15",
  // },
  // {
  //   id: 4,
  //   type: "audio",
  //   img: images.interview04.image,
  //   mbImg: images.interviewMB04.image,
  //   alt: images.interview04.alt,
  //   title: "Holistic Healing and Addiction Recovery",
  //   desc: "Exploring alternative healing methods in addiction recovery, including meditation and wellness.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Addiction",
  //   interviewDate: "2024-12-20",
  // },
  // Ayurveda category
  // {
  //   id: 6,
  //   type: "video",
  //   subType: "video",
  //   img: images.interview05.image,
  //   mbImg: images.interviewMB05.image,
  //   alt: images.interview05.alt,
  //   title: "Gurmukh Khalsa – Kundalini, Madonna, and a Youthful Spirit",
  //   desc: "Prepare to be uplifted by the sheer presence and wisdom of Gurmukh Khalsa, the legendary Kundalini Yoga teacher. At 82, her power and clarity are undeniable as she shares her unique perspective on Kundalini, navigating the challenge of describing its essence when language falls short. Gurmukh offers insights from her life, including her experiences raising kids, and reveals how she cultivates her own child-like attitude and young spirit, which she helps others cultivate too. This is an interview brimming with potent lessons for all ages.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: [
  //     "Meditation",
  //     "Yoga",
  //     "Spirituality & Religion",
  //     "Sacred Feminine",
  //   ],
  //   interviewDate: "2026-06-20",
  // },
  // {
  //   id: 7,
  //   type: "audio",
  //   img: images.interview04.image,
  //   mbImg: images.interviewMB04.image,
  //   alt: images.interview04.alt,
  //   title: "The Healing Power of Ayurvedic Herbs",
  //   desc: "A deep dive into the world of Ayurvedic herbs and their benefits for physical and mental well-being.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Ayurveda",
  //   interviewDate: "2024-11-15",
  // },
  // {
  //   id: 8,
  //   type: "video",
  //   subType: "video",
  //   img: images.interview06.image,
  //   mbImg: images.interviewMB06.image,
  //   alt: images.interview06.alt,
  //   title:
  //     "Marianna Harpreet – Business, Mallorca, and the Sages & Scientists Conference",
  //   desc: "Join us for a candid conversation with Marianna Harpreet, the visionary founder of the Deepak Foundation in Mallorca and organizer of the annual Sages & Scientists conference. Marianna shares her unique insights on the intersection of business and purpose, her deep connection to the island of Mallorca, and the often underestimated role our family backgrounds play in shaping who we become. This interview offers a compelling look at building a meaningful life and career, rooted in personal history and a passion for giving back.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: ["Yoga", "Health & Longevity", "Business"],
  //   interviewDate: "2026-06-15",
  // },
  // {
  //   id: 9,
  //   type: "audio",
  //   img: images.interview02.image,
  //   mbImg: images.interviewMB02.image,
  //   alt: images.interview02.alt,
  //   title: "Ayurveda and Diet: Tailoring Your Nutrition",
  //   desc: "Expert advice on how to design an Ayurvedic diet that aligns with your body type and health goals.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Ayurveda",
  //   interviewDate: "2024-11-28",
  // },
  // {
  //   id: 10,
  //   type: "video",
  //   img: images.interview03.image,
  //   mbImg: images.interviewMB03.image,
  //   alt: images.interview03.alt,
  //   title: "Ayurvedic Practices for Stress Relief",
  //   desc: "Practical Ayurvedic methods to manage stress and anxiety in the modern world.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Ayurveda",
  //   interviewDate: "2024-12-12",
  // },

  // Astrology category
  // {
  //   id: 11,
  //   type: "video",
  //   subType: "video",
  //   img: images.interview07.image,
  //   mbImg: images.interviewMB07.image,
  //   alt: images.interview07.alt,
  //   title:
  //     "Monika Vijh – Breaking Free from the Golden Cage: A Journey Beyond Life and Limit",
  //   desc: "Prepare for a truly profound experience with Monika Vijh, author of 'Devotee of the Void.' In this deeply personal interview, Monika shares the transformative account of her experience of dying and returning to life, offering unparalleled insights into existence beyond the veil. We also delve into her powerful reflections on breaking free from what she calls the 'golden cage' – the unseen limitations and expectations that often bind us. The conversation is beautifully punctuated as Monika reads excerpts from her evocative poetry, adding another layer of depth to her unique wisdom.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: ["Yoga", "Spirituality & Religion", "Meditation"],
  //   interviewDate: "2026-12-12",
  // },
  // {
  //   id: 12,
  //   type: "audio",
  //   img: images.interview01.image,
  //   mbImg: images.interviewMB01.image,
  //   alt: images.interview01.alt,
  //   title: "The Science and Mysticism of Astrology",
  //   desc: "A discussion with astrologers on the blend of science, mysticism, and personal belief systems.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Astrology",
  //   interviewDate: "2024-12-10",
  // },
  // {
  //   id: 13,
  //   type: "video",
  //   subType: "audio",
  //   img: images.interview08.image,
  //   mbImg: images.interviewMB08.image,
  //   alt: images.interview08.alt,
  //   title:
  //     "Annemarie Brown – Sattva Gems & The Practical Power of Vedic Astrology",
  //   desc: "Unlock the mysteries of the cosmos with Annemarie Brown, the insightful founder of Sattva Gems, an online business specializing in astrological gems. Annemarie demystifies Vedic astrology, explaining what it truly is beyond simple horoscopes. More importantly, she shares practical, actionable applications for this ancient science, demonstrating how understanding your unique cosmic blueprint can guide you in everyday decisions, from career choices to personal well-being. Discover how to harness the subtle energies of the universe for a more aligned and fulfilling life.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: ["Astrology", "Yoga"],
  //   interviewDate: "2026-12-05",
  // },
  // {
  //   id: 14,
  //   type: "audio",
  //   img: images.interview03.image,
  //   mbImg: images.interviewMB03.image,
  //   alt: images.interview03.alt,
  //   title: "Understanding Zodiac Signs and Compatibility",
  //   desc: "A breakdown of zodiac signs, their characteristics, and how they relate to compatibility in relationships.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Astrology",
  //   interviewDate: "2024-11-25",
  // },
  // {
  //   id: 15,
  //   type: "video",
  //   subType: "audio",
  //   img: images.interview09.image,
  //   mbImg: images.interviewMB09.image,
  //   alt: images.interview09.alt,
  //   title:
  //     "Ra – The Entrepreneur's Spiritual Quest: Finding a Guru and Giving Back",
  //   desc: "Join us on a compelling spiritual journey with Ra, an entrepreneur with a rich background in education. Ra candidly shares the challenges and profound experiences of his personal spiritual quest, including his long and often arduous search for a true guru. In this insightful conversation, he unpacks what a guru actually is beyond conventional understanding, and speaks passionately about his current work in giving back to society. This interview offers a unique perspective on dedication, perseverance, and the ultimate purpose of spiritual understanding in modern life.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: ["Spirituality & Religion", "Yoga", "Business", "Philanthropy"],
  //   interviewDate: "2026-12-05",
  // },

  // Sacred Feminine category
  // {
  //   id: 16,
  //   type: "video",
  //   img: images.interview04.image,
  //   mbImg: images.interviewMB04.image,
  //   alt: images.interview04.alt,
  //   title: "The Rise of the Sacred Feminine",
  //   desc: "Exploring the resurgence of feminine energy and its impact on culture and spirituality.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Sacred Feminine",
  //   interviewDate: "2024-11-28",
  // },
  // {
  //   id: 17,
  //   type: "audio",
  //   img: images.interview04.image,
  //   mbImg: images.interviewMB04.image,
  //   alt: images.interview04.alt,
  //   title: "Embracing the Divine Feminine",
  //   desc: "An intimate conversation on how women are reconnecting with their divine feminine power.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Sacred Feminine",
  //   interviewDate: "2024-11-28",
  // },
  // {
  //   id: 18,
  //   type: "video",
  //   img: images.interview04.image,
  //   mbImg: images.interviewMB04.image,
  //   alt: images.interview04.alt,
  //   title: "Sacred Feminine and the Power of Community",
  //   desc: "How the sacred feminine fosters collaboration, community, and compassion.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Sacred Feminine",
  //   interviewDate: "2024-11-15",
  // },
  // {
  //   id: 19,
  //   type: "audio",
  //   img: images.interview02.image,
  //   mbImg: images.interviewMB02.image,
  //   alt: images.interview02.alt,
  //   title: "Awakening the Goddess Within",
  //   desc: "A journey to awaken the goddess within and embrace feminine strength and wisdom.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Sacred Feminine",
  //   interviewDate: "2024-11-25",
  // },
  // {
  //   id: 20,
  //   type: "video",
  //   img: images.interview01.image,
  //   mbImg: images.interviewMB01.image,
  //   alt: images.interview01.alt,
  //   title: "Feminine Leadership: Shaping a New World",
  //   desc: "How feminine leadership is changing the world and creating a more inclusive future.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Sacred Feminine",
  //   interviewDate: "2024-11-20",
  // },
  // // Yoga category
  // {
  //   id: 21,
  //   type: "video",
  //   img: images.interview02.image,
  //   mbImg: images.interviewMB02.image,
  //   alt: images.interview02.alt,
  //   title: "The Philosophy Behind Yoga",
  //   desc: "A deep exploration into the philosophy and history of yoga.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Yoga",
  //   interviewDate: "2024-12-15",
  // },
  // {
  //   id: 22,
  //   type: "audio",
  //   img: images.interview02.image,
  //   mbImg: images.interviewMB02.image,
  //   alt: images.interview02.alt,
  //   title: "Yoga for Mind, Body, and Soul",
  //   desc: "Discover how yoga unites the mind, body, and soul for a holistic well-being.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Yoga",
  //   interviewDate: "2024-11-20",
  // },
  // {
  //   id: 23,
  //   type: "video",
  //   img: images.interview02.image,
  //   mbImg: images.interviewMB02.image,
  //   alt: images.interview02.alt,
  //   title: "The Evolution of Yoga in the Modern World",
  //   desc: "An insightful talk on the adaptation of ancient yoga practices to modern lifestyles.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Yoga",
  //   interviewDate: "2024-11-20",
  // },
  // {
  //   id: 24,
  //   type: "audio",
  //   img: images.interview02.image,
  //   mbImg: images.interviewMB02.image,
  //   alt: images.interview02.alt,
  //   title: "Healing through Yoga: Stories of Transformation",
  //   desc: "Real-life stories of how yoga has transformed individuals' lives physically and mentally.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Yoga",
  //   interviewDate: "2024-12-15",
  // },
  // {
  //   id: 25,
  //   type: "video",
  //   img: images.interview03.image,
  //   mbImg: images.interviewMB03.image,
  //   alt: images.interview03.alt,
  //   title: "Yoga as a Tool for Stress Management",
  //   desc: "Practical techniques in yoga for managing daily stress and anxiety.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Yoga",
  //   interviewDate: "2024-11-20",
  // },
  // // Past Life category
  // {
  //   id: 26,
  //   type: "video",
  //   img: images.interview03.image,
  //   mbImg: images.interviewMB03.image,
  //   alt: images.interview03.alt,
  //   title: "Understanding Past Lives and Reincarnation",
  //   desc: "An in-depth discussion on past lives, reincarnation, and the impact of our previous existences on our current life.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Past Life",
  //   interviewDate: "2024-08-05",
  // },
  // {
  //   id: 27,
  //   type: "audio",
  //   img: images.interview02.image,
  //   mbImg: images.interviewMB02.image,
  //   alt: images.interview02.alt,
  //   title: "Healing Through Past Life Regression Therapy",
  //   desc: "How past life regression therapy can heal traumas and bring clarity to unresolved emotional issues.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Past Life",
  //   interviewDate: "2024-09-10",
  // },

  // // Trauma category
  // {
  //   id: 28,
  //   type: "video",
  //   img: images.interview01.image,
  //   mbImg: images.interviewMB01.image,
  //   alt: images.interview01.alt,
  //   title: "Understanding Trauma and its Long-Term Effects",
  //   desc: "An expert talks about the different types of trauma and how it impacts mental health over time.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Trauma",
  //   interviewDate: "2024-08-25",
  // },
  // {
  //   id: 29,
  //   type: "audio",
  //   img: images.interview02.image,
  //   mbImg: images.interviewMB02.image,
  //   alt: images.interview02.alt,
  //   title: "Trauma Recovery: The Path to Healing",
  //   desc: "Practical advice on trauma recovery and coping mechanisms from a renowned therapist.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Trauma",
  //   interviewDate: "2024-09-20",
  // },

  // // Shamanism category
  // {
  //   id: 30,
  //   type: "video",
  //   img: images.interview02.image,
  //   mbImg: images.interviewMB02.image,
  //   alt: images.interview02.alt,
  //   title: "Shamanic Healing and Spirit Guides",
  //   desc: "An exploration of shamanic practices, connecting with spirit guides, and healing through rituals.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Shamanism",
  //   interviewDate: "2024-09-15",
  // },
  // {
  //   id: 31,
  //   type: "audio",
  //   img: images.interview04.image,
  //   mbImg: images.interviewMB04.image,
  //   alt: images.interview04.alt,
  //   title: "Modern Shamanism and Personal Transformation",
  //   desc: "Discover how modern-day shamanism can transform your life and deepen your spiritual journey.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Shamanism",
  //   interviewDate: "2024-09-05",
  // },
  // // Wellness category
  // {
  //   id: 32,
  //   type: "video",
  //   img: images.interview02.image,
  //   mbImg: images.interviewMB02.image,
  //   alt: images.interview02.alt,
  //   title: "The Importance of Holistic Wellness",
  //   desc: "Experts discuss the concept of holistic wellness, integrating mind, body, and spirit for a balanced life.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Wellness",
  //   interviewDate: "2024-07-30",
  // },
  // {
  //   id: 33,
  //   type: "audio",
  //   img: images.interview01.image,
  //   mbImg: images.interviewMB01.image,
  //   alt: images.interview01.alt,
  //   title: "Daily Practices for Wellness and Mental Clarity",
  //   desc: "Simple daily practices that can enhance overall wellness and bring mental clarity.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Wellness",
  //   interviewDate: "2024-08-18",
  // },

  // // Meditation category
  // {
  //   id: 34,
  //   type: "video",
  //   img: images.interview01.image,
  //   mbImg: images.interviewMB01.image,
  //   alt: images.interview01.alt,
  //   title: "Mastering the Art of Meditation",
  //   desc: "A guided session on meditation techniques to help quiet the mind and find inner peace.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Meditation",
  //   interviewDate: "2024-07-15",
  // },
  // {
  //   id: 35,
  //   type: "audio",
  //   img: images.interview02.image,
  //   mbImg: images.interviewMB02.image,
  //   alt: images.interview02.alt,
  //   title: "Meditation for Beginners",
  //   desc: "A beginner's guide to meditation, focusing on breathing techniques and mindfulness.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Meditation",
  //   interviewDate: "2024-10-21",
  // },
  // // Sound Healing category
  // {
  //   id: 36,
  //   type: "video",
  //   img: images.interview02.image,
  //   mbImg: images.interviewMB02.image,
  //   alt: images.interview02.alt,
  //   title: "The Power of Sound Healing",
  //   desc: "Learn how sound healing can help balance energies and bring a sense of calm to the mind and body.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Sound Healing",
  //   interviewDate: "2024-08-12",
  // },
  // {
  //   id: 37,
  //   type: "audio",
  //   img: images.interview02.image,
  //   mbImg: images.interviewMB02.image,
  //   alt: images.interview02.alt,
  //   title: "Vibrational Healing: The Science Behind Sound Therapy",
  //   desc: "An expert discusses the science behind sound therapy and how it affects our brain and body.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Sound Healing",
  //   interviewDate: "2024-08-22",
  // },
  // // Intuition category
  // {
  //   id: 38,
  //   type: "video",
  //   img: images.interview03.image,
  //   mbImg: images.interviewMB03.image,
  //   alt: images.interview03.alt,
  //   title: "Trusting Your Intuition: A Guide to Inner Knowing",
  //   desc: "An intuitive coach talks about how to strengthen and trust your inner voice.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Intuition",
  //   interviewDate: "2024-08-20",
  // },
  // {
  //   id: 39,
  //   type: "audio",
  //   img: images.interview03.image,
  //   mbImg: images.interviewMB03.image,
  //   alt: images.interview03.alt,
  //   title: "The Science of Intuition",
  //   desc: "Exploring the scientific studies that reveal the existence and accuracy of intuition.",
  //   video: "https://www.youtube.com/embed/-sCvA9FPzpQ?si=Iu3LTfZI4zdFRuHp",
  //   category: "Business",
  //   interviewDate: "2024-09-12",
  // },
];

export const interviewCategories = [
  "Addiction",
  "Art & Fashion",
  "Astrology",
  "Ayurveda",
  "Breathwork",
  "Business",
  "Entrepreneurship",
  "Family",
  "Health & Longevity",
  "History",
  "Holistic Health",
  "India",
  "Meditation",
  "Money",
  "Motherhood",
  "Music & Sound",
  "Philanthropy",
  "Performance",
  "Perspective Shift",
  "Politics",
  "Sacred Feminine",
  "Science",
  "Spirituality & Religion",
  "Sports",
  "Tantra",
  "Technology",
  "Transformation",
  "Wellness",
  "Yoga",
];

export const interviewTypes = ["Video Interviews", "Audio Interviews"];

export const interviewSortByTypes = [
  "Upcoming Interviews",
  "Latest Interviews",
  "Past Interviews",
];
